<div class="border rounded-large grow flex flex--column" *ngIf="profile$ | async as profile">
  <div class="pr-xsmall grow">
    <div class="flex flex--wrap">
      <span class="font-heading-5 nordic-blue-900-text flex-1 ms-xsmall-b"
        >{{ 'plus.pointsBalance.availableAwardPoints' | finLocalization }}
      </span>
    </div>
    <div class="flex flex--middle ms-xsmall-y nordic-blue-900-text">
      <fcom-icon class="icon-large ms-small-r" [name]="SvgLibraryIcon.AVIOS_CURRENCY" data-avios-logo></fcom-icon>
      <span class="bold-type font-heading-3">{{ profile.awardPoints | finPoints }}</span>
    </div>
    <p *finLet="showPointExpiry$ | async as show" data-testid="using-points">
      {{
        (profile.tier === ProfileTier.JUNIOR
          ? 'LOYALTY.pointsBalance.juniorBenefits'
          : (hideZeroPtsTiersMsg | async)
            ? 'LOYALTY.pointsBalance.noPointsMainText'
            : show
              ? 'LOYALTY.pointsBalance.usingToExtend'
              : 'LOYALTY.pointsBalance.usingPoints'
        ) | finLocalization
      }}
    </p>
  </div>
  <div class="flex--end">
    <div class="align-right pr-xsmall">
      <fcom-button
        (clickBtn)="ctaClicked.emit()"
        class="align-right"
        [text]="
          ((hideZeroPtsTiersMsg | async) ? 'LOYALTY.pointsBalance.collectAvios' : 'LOYALTY.pointsBalance.usePoints')
            | finLocalization
        "
      ></fcom-button>
    </div>

    <div
      class="flex flex--middle ps-medium-x ps-xsmall-y nordic-blue-25-bg rounded-bottom-large font-body-2 regular-type"
      test-data-expiration-footer
    >
      <fcom-icon
        class="flex--shrink0 icon-small nordic-blue-900-text ms-xsmall-r"
        [name]="SvgLibraryIcon.INFO_BLOCK"
      ></fcom-icon>

      <div *finLet="showPointExpiry$ | async as show">
        {{
          ((hideZeroPtsTiersMsg | async)
            ? 'LOYALTY.pointsBalance.noPointsFooterText'
            : show
              ? 'LOYALTY.pointsBalance.expire'
              : (tier$ | async) === ProfileTier.LUMO
                ? 'LOYALTY.pointsBalance.noExpireLumo'
                : 'LOYALTY.pointsBalance.noExpire'
          )
            | finLocalization
              : {
                  date: expirationDate$ | async | finDateFormat: 'DATE',
                  tier: TIER_DATA_MAP[profile.tier]?.tierName ?? '',
                }
        }}
      </div>
    </div>
  </div>
</div>
